import React from 'react';
import { RegimeTable } from '../../Components/Regimes/RegimeTable';

export const RegimesScreen = () => {
  return (
    <div className="role-screen">
      <RegimeTable />
    </div>
  );
};
